// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.row[data-v-763f219f] {\n  margin-bottom: 2vh;\n}\n.form-size[data-v-763f219f] {\n  width: 90%;\n  margin: 1vh auto 1vh;\n  text-align: center;\n}\niframe[data-v-763f219f] {\n  width: 95vw;\n  height: 100vh;\n  border-left: 5px solid;\n  color: #00368f;\n}\n.btn-width[data-v-763f219f] {\n  background-color: #00368f;\n  margin: 0.8vh 1vh auto;\n}\n", ""]);
// Exports
module.exports = exports;
